import { Box, Button, Text, Popover, PopoverTrigger, PopoverContent, PopoverBody } from '@chakra-ui/react';

import { EditIcon2, MoreIcon, TrashcanIcon } from '@assets/icons';
import { useConfirmModal } from '@store/useConfirmModal';
import { useApp } from '@pages/UploadMappingV2/context/AppContext';
import { usePieceStore } from '@pages/UploadMappingV2/hooks/state/useAddProductSatuan';

function ActionHead({ allValue }) {
    const { set } = useConfirmModal();
    const { setEditPiece, deletePiece, setIsAdding } = usePieceStore();
    const { onOpenModalAddProductPiece } = useApp();

    const handleDelete = () => {
        set({
            isOpen: true,
            title: 'Hapus product?',
            desc: 'Data yang telah dituliskan akan hilang, perlu melakukan pengisian ulang untuk menambahkan atau menghubungkan produk.',
            btnLabelYes: 'Ya, Hapus',
            btnLabelNo: 'Kembali',
            onSubmit: () => deletePiece(allValue.localId),
        });
    };

    const handleEdit = () => {
        setEditPiece(allValue);
        setIsAdding(false);
        onOpenModalAddProductPiece();
    };

    return (
        <Popover placement="bottom-start">
            <PopoverTrigger>
                <Button variant={'unstyled'} justifySelf={'end'} px={0} minW={'10px'}>
                    <MoreIcon />
                </Button>
            </PopoverTrigger>
            <PopoverContent>
                <PopoverBody w={'full'} _hover={{ bg: 'sagitarius.100' }}>
                    <Button
                        variant={'unstyled'}
                        onClick={handleEdit}
                        color={'sagitarius.500'}
                        w={'full'}
                        justifyContent={'start'}
                    >
                        <EditIcon2 size={18} />
                        Edit
                    </Button>
                </PopoverBody>
                <PopoverBody _hover={{ bg: 'danger.100' }}>
                    <Button variant={'unstyled'} onClick={handleDelete} color={'danger.500'}>
                        <TrashcanIcon size={18} />
                        Delete
                    </Button>
                </PopoverBody>
            </PopoverContent>
        </Popover>
    );
}

export const tableHeadListsProductSatuan = [
    {
        key: 'brand',
        title: 'Brand',
        width: '120px',
        tableDataList: ({ value }) => {
            return (
                <Box>
                    <Text>{value}</Text>
                </Box>
            );
        },
    },
    {
        key: 'name',
        title: 'Produk Paragon',
        width: '420px',
        tableDataList: ({ value }) => {
            return (
                <Box>
                    <Text>{value}</Text>
                </Box>
            );
        },
    },
    {
        key: 'barcode',
        title: 'Kode Produk Paragon',
        width: '230px',
        tableDataList: ({ value }) => {
            return (
                <Box>
                    <Text>{value}</Text>
                </Box>
            );
        },
    },
    {
        key: 'code',
        title: 'Kode Produk di Toko',
        width: '230px',
        tableDataList: ({ value }) => {
            return (
                <Box>
                    <Text>{value}</Text>
                </Box>
            );
        },
    },
    {
        key: 'action',
        title: 'Action',
        width: '30px',
        align: 'right',
        tableDataList: ({ allValue }) => {
            return <ActionHead allValue={allValue} />;
        },
    },
];
